module.exports = __webpack_public_path__ + "img/eventbridge.a5da24fd.svg";